'use client'

import type { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical'
import {
  LinkJSXConverter,
  RichText,
  type JSXConvertersFunction,
} from '@payloadcms/richtext-lexical/react'

import { cn } from '@/lib/utils'
import { getPagePath } from '@/utilities/getPagePath'

const converters: JSXConvertersFunction = ({ defaultConverters }) => ({
  ...defaultConverters,
  ...LinkJSXConverter({
    internalDocToHref: ({ linkNode }) => {
      const f = linkNode.fields
      if (f.linkType === 'custom' && f.url) return f.url
      if (f.linkType === 'internal' && f.doc?.value) {
        const v = f.doc.value
        if (typeof v === 'object' && v !== null && 'slug' in v) {
          const slug = (v as { slug?: unknown }).slug
          if (typeof slug === 'string') return getPagePath(slug)
        }
      }
      return '#'
    },
  }),
})

type PayloadRichTextProps = {
  className?: string
  data: SerializedEditorState | null | undefined | unknown
  disableContainer?: boolean
}

export function PayloadRichText({ className, data, disableContainer }: PayloadRichTextProps) {
  if (!data || typeof data !== 'object' || !('root' in (data as object))) return null

  const state = data as SerializedEditorState

  return (
    <RichText
      className={cn('payload-rich-text', className)}
      converters={converters}
      data={state}
      disableContainer={disableContainer}
    />
  )
}
